export const inputgroup = {
  colorScheme: {
    light: {
      addon: {
        background: '{surface.100}',
        color: '{neutral.900}',
        borderColor: '{surface.600}',
      },
    },
    dark: {
      addon: {
        background: '#464a5c',
        color: 'white',
        borderColor: '#5B5F69',
      },
      root: {
        focusBorderColor: 'var(--p-primary-color)',
        hoverBorderColor: 'var(--p-primary-color)',
        color: 'white',
      },
    },
  },
};
